import {InjectionToken} from "@angular/core";

export const IS_BROWSER = new InjectionToken<string>('isBrowser');
export const ENVIRONMENT = new InjectionToken<string>('environment');
